ko.components.register('pie-chart', {
	viewModel: function(params) {
		var self = this;

		self.name = ko.observable(params.name || 'charts');
		self.params = ko.observable(params.params || {});

		self.navigation = ko.observableArray(params.navigation || []);
		self.selected = ko.observable(params.selected || '');

		self.data = ko.observableArray(params.data || []);
		self.options = ko.observable(params.options || {});
		self.description = ko.observable('');

		self.loading = ko.observable(false);

		self.isChartVisible = ko.pureComputed(function() {
			return self.data.length && self.options();
		});

		self.isSelected = function(item) {
			if(self.selected() && item) {
				return self.selected() === item.action;
			}
			return false;
		};

		self.selectChart = function(item) {
			self.selected(item.action);
			self.loadData(item.action);
		};

		self.setChartOptions = function(type) {
			if(type === 'pie') {
				var isLargeData = self.data().length > 25;
				self.options({
					series: {
						lines: { show: true },
						points: { show: true },
						pie: {
							show: true,
							label: {
								show: true,
								formatter: function(label, series) {
									if(isLargeData && series.data[0][1] < 2)
										return '';
									return '<small class="badge badge-light">' + label + '</small>';
								}
							}
						}
					},
                    legend: {
						show: true,
                        labelFormatter: function(label, series) {
                        	return '<strong style="color:'+series.color+'">' + label + '</strong> ' + Math.round(series.percent) + '% (' + series.data[0][1] + ')';
                        },
						noColumns: 5,
						container: $('.pie-chart-legend:first'),
						sorted: "descending",
					}
				});
			}
		};

		self.loadData = function(action) {
			if(self.loading())
				return;
			self.loading(true);
			App.ajaxRequest(self.name() + '/' + action, self.params()).done(function(r) {
				if(r && r.ok) {
					if(r.data) {
						self.data(r.data);
						self.description(r.description || '');
						self.setChartOptions(r.type || 'pie');
					}
				}
			}).always(function() {
				self.loading(false);
			});
		};

		self.loadNavigation = function() {
			self.selected('');
			self.navigation.removeAll();

			App.ajaxRequest(self.name() + '/list', self.params()).done(function(r) {
				if(r && r.ok) {
					if(r.items) {
						self.navigation(r.items);
						var item = r.items.shift();
						if(item) self.selectChart(item);
					}
				}
			});
		};

		self.loadNavigation();
	},
	template: "<div class=\"row\">\n\t<div class=\"col-md-9 col-lg-10\" style=\"min-height:600px\">\n\t\t<span class=\"spinner spinner-border text-success\" data-bind=\"visible: loading()\" style=\"position:absolute;z-index:1;\"></span>\n\t\t<div class=\"pie-chart-view\" data-bind=\"flot: {'data': data(), 'options': options()}\"></div>\n\t\t<div class=\"pie-chart-description\" data-bind=\"html: description()\"></div>\n\t\t<div class=\"pie-chart-legend\"></div>\n\t</div>\n\t<div class=\"col-md-3 col-lg-2 border-gray border-left\">\n\t\t<ul class=\"list-group list-group-flush pie-chart-navigation\" data-bind=\"foreach: navigation()\">\n\t\t<li class=\"list-group-item list-group-item-action cursor-pointer\" data-bind=\"text: label, click: $parent.selectChart, css: {'active': $parent.isSelected($data)}\"></li>\n\t\t</ul>\n\t</div>\n</div>"
});